<template>
  <div
    v-element-value="_value"
    class="hkl-checkbox"
  >
    <input
      type="checkbox"
      :checked="checked"
      v-bind="$attrs"
      @change="change"
      v-on="$listeners"
    >
    <div
      v-if="$slots.default"
      @click="() => !$attrs.disabled && change()"
    >
      <slot />
    </div>
  </div>
</template>
<script>
import { computed, unref } from 'vue-demi'

const SOURCE = '_value'
const EVENT = '_change'

export default {
  name: 'HKLCheckbox',
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: [SOURCE],
  setup (props, { emit }) {
    const currentValue = computed(() => !!props[SOURCE])
    return {
      checked: computed(() => unref(currentValue)),
      change: () => emit(EVENT, !unref(currentValue)),
    }
  },
}
</script>

<style lang="scss" scoped>
$buttonHeight: 18px;

.hkl-checkbox {
  display: flex;
  flex-direction: row;
  input {
    margin: 0;
    padding: 0;
    height: $buttonHeight + 2px;
    width: 20px;
    &:checked:after {
      height: $buttonHeight;
      width: 18px;
      font-size: 18px;
    }
    &:not([disabled]) {
      cursor: pointer;
    }

    & + * {
      margin-left: 5px;
      line-height: $buttonHeight;
    }
    &:not([disabled]) + * {
      cursor: pointer;
    }
  }
  &.small input {
    min-width: $buttonHeight - 4px;
    height: $buttonHeight - 4px;
    width: $buttonHeight - 4px;
    &:checked:after {
      height: $buttonHeight - 4px;
      width: $buttonHeight - 4px;
      font-size: $buttonHeight - 4px;
    }
  }
}
</style>
